import {FeatureFlagEnum} from 'src/api/ProactApiClient';
import useActiveFeatureFlags from './useActiveFeatureFlags';

/**
 * Whether the `DocumentReviews` feature flag (approval/acknowledgment
 * workflow on Document Management) is active for this instance. Gates rule
 * management, status badges/banners, and round history everywhere they
 * appear; combine with `useModulePermissions(ModuleEnum.Documents)` for
 * operation-level checks (rule CRUD requires Documents Update).
 */
export const useDocumentReviewsFeature = (): boolean => {
  const activeFeatureFlags = useActiveFeatureFlags();
  return activeFeatureFlags?.includes(FeatureFlagEnum.DocumentReviews) ?? false;
};
